import { render } from "./editadmin.vue?vue&type=template&id=25585b9c"
import script from "./editadmin.vue?vue&type=script&lang=js"
export * from "./editadmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__